import React, { useState, useEffect } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { storage, db } from '../firebase';
import NavbarAdmin from '../components/NavbarAdmin';
import './styles/ManageStatDom.css';
import { deleteObject, ref } from 'firebase/storage';

const ManageActs = () => {
  const [actualites, setActualites] = useState([]);

  useEffect(() => {
    const fetchActualites = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'actualites'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Assuming your timestamp field is named 'timestamp' and it is a Firestore Timestamp object
        setActualites(data.sort((a, b) => (b.timestamp?.toDate() || new Date()) - (a.timestamp?.toDate() || new Date())));
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchActualites();
  }, []);

  const handleDelete = async (id, photoUrl) => {
    const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer cette Actualité ?");
    if (confirmDelete) {
      try {
        if (photoUrl) {
          const photoPath = photoUrl.split('/o/')[1].split('?')[0].replace('%2F', '/');
          const photoRef = ref(storage, `/${photoPath}`);
          await deleteObject(photoRef);
        }

        await deleteDoc(doc(db, 'actualites', id));
        alert("Actualité supprimée avec succès!");

        // Refresh the list after deletion
        const querySnapshot = await getDocs(collection(db, 'actualites'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setActualites(data.sort((a, b) => (b.timestamp?.toDate() || new Date()) - (a.timestamp?.toDate() || new Date())));
      } catch (error) {
        console.error("Error deleting document or photo: ", error);
      }
    }
  };

  const headingStyle = {
    fontSize: '2rem', 
    color: '#cc6699',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0', 
    textAlign: 'center', 
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px' 
  };

  return (
    <div>
      <NavbarAdmin />
      <div className="manage-statistics">
        <h2 style={headingStyle}>Gérer les Actualités</h2>
        <table>
          <thead>
            <tr>
              <th>Titre</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {actualites.map(act => (
              <tr key={act.id}>
                <td>{act.title}</td>
                <td>
                  <button
                    onClick={() => handleDelete(act.id, act.photo)}
                    className="supprimer"
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageActs;
